import React, { useState, useEffect } from 'react';
import { array, bool, func, object, string } from 'prop-types';

import { useFormik } from 'formik';
import * as Yup from 'yup';

import { isEmpty } from 'lodash';

import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { Grid, GridNoRecords, GridColumn as Column } from '@progress/kendo-react-grid';

import { process as kendoProcess } from '@progress/kendo-data-query';

import TechnicianForm from './TechnicianForm';

import { connect } from 'react-redux';

import * as BobActions from '../../../actions/bobActions';
import * as DashboardActions from '../../../actions/dashboardActions';

import classes from '../CreateEntityModal.module.css';


const UserTypeValidationSchema = Yup.object().shape({
    userType: Yup.string().required(),
});

const USER_TYPE_DEFAULT_FORM_VALUES = {
    userType: '',
};

const USER_TYPES = [
    {
        id:   'CompanyAdmin',
        name: 'CompanyAdmin' 
    },
    {
        id:   'ApplicationUser',
        name: 'ApplicationUser' 
    },
    {
        id:   'Technician',
        name: 'Technician' 
    }
];

const initialDataState = {
    sort: []
};

const UserType = ({
    createOrUpdateUser,
    deleteUserType,
    isCreateUser,
    seniorityLevels,
    specialties,
    selectedUser,
    selectedUserTypeList,
    setSelectedUserTypeList,
    setIsTabDataDirty,
    skillLevel,
    skillTypes,
    userFormattedAddress,
    userContactDetails,
    ...props
}) => {
  
    const [formattedSeniorityLevels, setFormattedSeniorityLevels] = useState([]);
    const [formattedSpecialties, setFormattedSpecialties] = useState([]);
    const [activeUserType, setActiveUserType] = useState('');
    const [dataState, setDataState] = useState(initialDataState);

    const userTypeFormik = useFormik({
        initialValues:      USER_TYPE_DEFAULT_FORM_VALUES,
        validationSchema:   UserTypeValidationSchema,
        enableReinitialize: true,
        onSubmit:           async (values, { setSubmitting }) => {
            var userTypeList = selectedUserTypeList;
            userTypeList.push({usertype: values.userType, userAttributes: {}});
            setSelectedUserTypeList(userTypeList);

            userTypeFormik.setFieldValue('userType', '', false);
        }
    });

    useEffect(() => {
        const init = async () => {
        };

        if ( selectedUser && selectedUser.userId ) init();
    }, [selectedUser]);

    useEffect(() => {
        if (!isEmpty(seniorityLevels)) {
            const payload = seniorityLevels.map(seniorityLevel => {
                return { id: seniorityLevel.id, name: seniorityLevel.label };
            });

            const formatted = payload;

            setFormattedSeniorityLevels(formatted);
        }
    }, [seniorityLevels]);

    useEffect(() => {
        if (!isEmpty(specialties) && !isEmpty(specialties[0].items)) {
            const payload = specialties[0].items.map(specialtie => {
                return { id: specialtie.id, name: specialtie.label };
            });

            const formatted = payload;

            setFormattedSpecialties(formatted);
        }
    }, [specialties]);

    const removeUserType = async index => {
        let selectedUserTypeListUpdate = selectedUserTypeList;

        // call delete userType API on upate time only
        if (selectedUserTypeListUpdate[index].id) {
            const tempUserTypeUserId = selectedUserTypeListUpdate[index].id;
            await deleteUserType(tempUserTypeUserId);
        }

        selectedUserTypeListUpdate.splice(index, 1);
        setSelectedUserTypeList([...selectedUserTypeListUpdate]);

        // set previous user type as active 
        if (!isEmpty(selectedUserTypeListUpdate) && index > 0) {
            const previous = selectedUserTypeListUpdate[index - 1];
            setActiveUserType(previous.usertype);
        }
    };

    const technicianSave = (formvalues, index) => {
        let selectedUserTypeListUpdate = selectedUserTypeList;
        selectedUserTypeListUpdate[index].userAttributes = formvalues;
        setSelectedUserTypeList([...selectedUserTypeListUpdate]);
    };

    const userTypeButtonClick = (type) => {
        setActiveUserType(type);
    };
    
    const handleSubmit = () => {
        // save selected usertype
        const unsavedUserType = selectedUserTypeList.filter(item => !item.id);

        // create time we can add multiple userType
        if (isCreateUser) {
            setActiveUserType(userTypeFormik.values.userType);
            userTypeFormik.handleSubmit();
        } else {
            // update time we can add only one userType at a time
            if (!isEmpty(unsavedUserType)) {
                setIsTabDataDirty(true);
            } else {
                setActiveUserType(userTypeFormik.values.userType);
                userTypeFormik.handleSubmit();
            }
        }
    };

    const userTypeValidation = () => {
        let isValidUserType = true;
        let tempUserTypes = selectedUserTypeList.filter(item => item.usertype === userTypeFormik.values.userType);
        if (isEmpty(tempUserTypes)) {
            isValidUserType = false;
        }
        return isValidUserType;
    };

    const onDataStateChange = e => {
        setDataState(e.dataState);
    };
    
    return (
        <div className={classes.technicianColumn}>
            <div className={classes.userTypeSelection}>
                <FormControl variant="outlined" size="small" className={classes.inputWrapper}>
                    <p className={classes.userFormTitleField}>User Types</p>
                    <Select
                        value={userTypeFormik.values.userType}
                        onChange={ e => {
                            userTypeFormik.handleChange(e);
                        }}
                        className={classes.select}
                        inputProps={{
                            name:   'userType',
                            id:     'userType',
                            onBlur: userTypeFormik.handleBlur
                        }}
                        error={Boolean(userTypeFormik.errors.userType) && Boolean(userTypeFormik.touched.userType)}
                    >
                        {
                            USER_TYPES.map(type =>
                                <MenuItem
                                    key={type.id}
                                    value={type.id}
                                >
                                    {type.name}
                                </MenuItem>
                            )
                        }
                    </Select>
                    {userTypeFormik.touched.userType &&
                                userTypeFormik.errors.userType && <FormHelperText className={classes.error}>{userTypeFormik.errors.userType}</FormHelperText>}
                </FormControl>
                <Button
                    className={`${classes.Button} ${classes.userTypeAddButton}`}
                    variant="contained"
                    disabled={userTypeValidation()}
                    onClick={() => handleSubmit()}
                >
                    Add
                </Button>
            </div>
            <div className={classes.userTypeButtonsWrapper}>
                {
                    selectedUserTypeList.map( (selectedUserType, id) => (
                        <div key={`user-type-button-${id}`} className={classes.userTypeButton}>
                            <Button
                                className={`${classes.Button} ${activeUserType === selectedUserType.usertype ? classes.activeButton : ''}`}
                                variant="contained"
                                onClick={() => userTypeButtonClick(selectedUserType.usertype)}
                            >
                                {selectedUserType.usertype}
                            </Button>
                        </div>
                    ))
                }
            </div>
            {
                selectedUserTypeList.map( (selectedUserType, id) => (
                    <div key={`user-type-${id}`}>
                        {
                            selectedUserType.usertype === 'Technician' && activeUserType === 'Technician' ?
                                <div className={classes.userTypeForm}>
                                    <div className={classes.technicianHeader}>
                                        <div>
                                            <span className={classes.userFormTitleField}>{selectedUserType.usertype.toString()}</span>
                                        </div>
                                        <div>
                                            <Button
                                                onClick={() => removeUserType(id)}
                                            >
                                                <i className="fa fa-trash" aria-hidden="true" />
                                            </Button>
                                        </div>
                                    </div>
                                    <TechnicianForm
                                        index={id}
                                        onSave={technicianSave}
                                        formattedSeniorityLevels={formattedSeniorityLevels}
                                        formattedSpecialties={formattedSpecialties}
                                        skillLevel={skillLevel}
                                        skillTypes={skillTypes}
                                        selectedUser={selectedUser}
                                        technicianData={selectedUserType}
                                        userFormattedAddress={userFormattedAddress}
                                    />
                                    <hr />
                                </div> : null
                        }
                        {
                            (selectedUserType.usertype === 'CompanyAdmin' && activeUserType === 'CompanyAdmin') || 
                            (selectedUserType.usertype === 'ApplicationUser' && activeUserType === 'ApplicationUser') ?
                                <div className={classes.userTypeForm}>
                                    <div className={classes.technicianHeader}>
                                        <div>
                                            <span className={classes.userFormTitleField}>{selectedUserType.usertype.toString()}</span>
                                        </div>
                                        <div>
                                            <Button
                                                onClick={() => removeUserType(id)}
                                            >
                                                <i className="fa fa-trash" aria-hidden="true" />
                                            </Button>
                                        </div>
                                    </div>
                                </div> : null
                        }
                    </div>    
                ))
            }
            {
                activeUserType === 'Contact' ?
                    <div className={classes.userTypeForm}>
                        <Grid
                            sortable={{
                                mode: 'single'
                            }}
                            className={classes.UserContactKendoGrid}
                            data={kendoProcess(userContactDetails, dataState)}
                            {...dataState}
                            onDataStateChange={onDataStateChange}
                            reorderable
                        >   
                            {
                                isEmpty(userContactDetails) ?
                                    <GridNoRecords>
                                        No Contact
                                    </GridNoRecords>
                                    :
                                    null
                            }
                            <Column field="clientName" title="Client" width={300} />
                            <Column field="siteName" title="Site" width={300} />
                            <Column field="titleDescription" title="Title" width={300} />
                        </Grid>
                    </div> : null

            }
        </div>
    );
};

UserType.propTypes = {
    close:       func,
    companyInfo: object,
    currentUser: object,
    errors:      array,
    isLoading:   bool,
    open:        bool,
    rule:        object,
    title:       string
};

const mapStateToProps = state => {
    return {
        companyInfo:        state.companyInfo,
        currentUser:        state.currentUser,
        errors:             state.messages.errors,
        entityRules:        state.bob.entityRules,
        isLoading:          state.ui.isLoading,
        navClients:         state.bob.navClients,
        sites:              state.site.sites,
        targetNavClient:    state.bob.targetNavClient,
        targetNavSite:      state.bob.targetNavSite,
        targetNavEquipment: state.bob.targetNavEquipment,
        seniorityLevels:    state.architect.seniorityLevels,
        specialties:        state.architect.specialties,
        skillLevel:         state.job.skillLevel,
        skillTypes:         state.job.skillTypes
    };
};

const mapDispatchToProps = {
    ...BobActions,
    ...DashboardActions
};

export default connect(mapStateToProps, mapDispatchToProps)(UserType);
